// extracted by mini-css-extract-plugin
export default {"Wrapper":"WorkPermitsActions_Wrapper__jv1tL"};